<div
  class="is-auth-layout is-flex is-justify-content-center is-flex-direction-column is-align-items-center"
>
  <img
    class="brand"
    src="../../../assets/baloosoft_logo_dark.svg"
    width="200"
  />
  <h4 *ngIf="title" class="mb-2">{{ title }}</h4>
  <h6 *ngIf="description" class="mb-5">{{ description }}</h6>
  <img [src]="getLoginImage()" width="150" class="mb-5" />
  <router-outlet></router-outlet>
  <div *ngIf="footer" class="auth-footer" [innerHTML]="footer"></div>
</div>
